import { connect } from 'react-redux';

import { selectIsLoading } from '../SecuritySelector';

const LoadingAuthentication = ({ children, isLoading }) => (isLoading ? children : null);

const mapStateToProps = (state) => ({
    isLoading: selectIsLoading(state),
});

export default connect(mapStateToProps)(LoadingAuthentication);
